import * as Sentry from '@sentry/vue'
import Vue from 'vue'

const sentryEnvironment = process.env.VUE_APP_ENV || 'production'
// eslint-disable-next-line no-console
console.info('[SENTRY ENV]', sentryEnvironment)
/*
 * NOTE: VUE_APP_TELEMETRY_DISABLED is set by `yarn start:env` (scripts/start-env.js).
 * When the dev server points at a real cluster (prod, preprod, legacy, milan),
 * Sentry must NOT initialize — otherwise local dev sessions stream error reports
 * and full session replays (replaysSessionSampleRate=1.0 in production) to the
 * production Sentry project.
 */
if (sentryEnvironment && sentryEnvironment !== 'local' && process.env.VUE_APP_TELEMETRY_DISABLED !== 'true') {
  let release
  try {
    const info = require('../../public/health.json')
    release = info.VERSION
  } catch (err) {
    console.error(err)
    release = 'local'
  }

  Sentry.init({
    Vue,
    dsn: 'https://77e5cdbf2b899761f14cf5121b63d106@sentry.ovhcloud.com/142',
    integrations: [
      Sentry.replayIntegration({
        blockAllMedia: false,
        unmask: ['.s-unmask']
      }),
      Sentry.replayCanvasIntegration()
    ],
    release,
    attachProps: true,
    logErrors: true,
    environment: sentryEnvironment,
    // Session Replay
    replaysSessionSampleRate: sentryEnvironment === 'production' ? 1.0 : 0.5,
    replaysOnErrorSampleRate: 1.0
  })
}
